import React, { useEffect, useState } from 'react';
import { Container, Form, Header, Icon, Breadcrumb, Button, Grid, Placeholder, Segment, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { useHistory, useLocation, useParams } from 'react-router';
import { useBookWorkshopForm } from './useBookWorkshopForm';
import { getWorkshopTypeList } from '../../../Services/WorkshopServices';
import { useRegisteredJobSeekers } from './useRegisteredJobSeekers';
import moment from 'moment';
import { RegisteredJobSeekers } from './RegisteredJobSeekers';

type WorkshopTypeOptions = {
    id: number,
    displayName: string,
}

export function BookWorkshopForm() {
    let { WId } = useParams<{ WId: string }>();
    let [values, masterData, errors, touched, isLoading, isSubmitting, isValid, submitSuccess, errorMessage, registerRef, handleChange, handleBlur, handleSubmit] = useBookWorkshopForm();
    let [listData, isListLoading, handleDeleteJobSeeker, handleExport] = useRegisteredJobSeekers(parseInt(WId));
    const history = useHistory();
    //console.log(masterData);
    const [workshopTypes, setWorkshopTypes] = useState<WorkshopTypeOptions[]>([]);

    useEffect(() => {
        getWorkshopTypeList().then((response) => {
            if (response.status === 200 && response.data) {
                setWorkshopTypes(response.data as WorkshopTypeOptions[]);
            }
        });

    }, []);

    function handleBackToList() {
        history.push('/JobSeekerWorkshops');
    }

    return <Container className='providers-container'>
        <Header as='h1' style={{ marginTop: '2.0rem', marginBottom: '0.5rem' }}>Book Job Seeker Workshop Spot</Header>
        <hr style={{ marginBottom: '1.0rem' }} />
        <Breadcrumb style={{ marginBottom: '1.0rem' }}>
            <Breadcrumb.Section link><Link to='/'>Home</Link></Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section link><Link to={'/JobSeekerWorkshops'}>Job Seeker Workshops</Link></Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section active>Book Job Seeker Workshop Spot</Breadcrumb.Section>
        </Breadcrumb>

        <Segment basic style={{ padding: 0 }}>
            <Grid columns={1}>
                {
                    !masterData &&
                    <Grid.Column>
                        <Placeholder fluid>
                            <Placeholder.Paragraph>
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                            </Placeholder.Paragraph>
                        </Placeholder>
                    </Grid.Column>
                }
                {
                    masterData &&
                    <Grid.Column>
                        <Header as='h2' attached='top' inverted className='ESP-list'>
                            {workshopTypes.length > 0 ? (workshopTypes.filter((item) => { return item.id.toString() == masterData?.workshopTypeId })[0].displayName) : ''} - Registration
                        </Header>
                        <Segment attached>

                            <Grid columns={2}>
                                <Grid.Row>
                                    <Grid.Column mobile={16} tablet={4} computer={2}>Date</Grid.Column>
                                    <Grid.Column mobile={16} tablet={12} computer={14}>{moment(masterData.startDate).format('dddd, MMM D, YYYY - hh:mm A')}{' to ' + moment(masterData.endDate).format('hh:mm A')}</Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column mobile={16} tablet={4} computer={2}>Location</Grid.Column>
                                    {
                                        masterData.workshopMode !== 'Online' && masterData.location &&
                                        <Grid.Column mobile={16} tablet={12} computer={14}><p dangerouslySetInnerHTML={{ __html: (masterData.location || '').replaceAll('\n', "<br />\r\n") }}></p></Grid.Column>
                                    }
                                    {
                                        masterData.workshopMode === 'Online' &&
                                        <Grid.Column mobile={16} tablet={12} computer={14}><span>Online</span></Grid.Column>
                                    }
                                </Grid.Row>
                                {

                                    masterData.workshopMode === 'Online' &&
                                    <Grid.Row>
                                        <Grid.Column mobile={16} tablet={4} computer={2}>Additional Information</Grid.Column>
                                        <Grid.Column mobile={16} tablet={12} computer={14}><p dangerouslySetInnerHTML={{ __html: (masterData.meetingInformation || '').replaceAll('\n', "<br />\r\n") }}>
                                        </p></Grid.Column>


                                    </Grid.Row>
                                }
                                {

                                    masterData.workshopMode === 'In-Person' &&
                                    <Grid.Row>
                                        <Grid.Column mobile={16} tablet={4} computer={2}>Room number</Grid.Column>
                                        <Grid.Column mobile={16} tablet={12} computer={14}><p dangerouslySetInnerHTML={{ __html: (masterData.roomNumber || '').replaceAll('\n', "<br />\r\n") }}>
                                        </p></Grid.Column>


                                    </Grid.Row>
                                }
                            </Grid>
                        </Segment>
                    </Grid.Column>
                }
            </Grid>
        </Segment>
        <Grid columns={2} style={submitSuccess ? { margin: 0 } : {}}>
            {
                !submitSuccess &&
                <>
                    <Grid.Column>
                        <Form loading={isSubmitting}>
                            <Form.Input className={!(!errors.firstName || !touched.firstName) ? 'mb-0' : ''}
                                required
                                fluid
                                label='First Name'
                                onChange={(event, data) => {
                                    handleChange(data.value, 'firstName');
                                }}
                                onBlur={
                                    () => { handleBlur('firstName') }
                                }
                                error={!(!errors.firstName || !touched.firstName) ? true : false}
                            />
                            {
                                !(!errors.firstName || !touched.firstName) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.firstName}</div>
                            }
                            <Form.Input className={!(!errors.lastName || !touched.lastName) ? 'mb-0' : ''}
                                required
                                fluid
                                label='Last Name'
                                onChange={(event, data) => {
                                    handleChange(data.value, 'lastName');
                                }}
                                onBlur={
                                    () => { handleBlur('lastName') }
                                }
                                error={!(!errors.lastName || !touched.lastName) ? true : false}
                            />
                            {
                                !(!errors.lastName || !touched.lastName) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.lastName}</div>
                            }
                            <Form.Input className={!(!errors.phoneNumber || !touched.phoneNumber) ? 'mb-0' : ''}

                                fluid
                                label='Phone Number'
                                onChange={(event, data) => {
                                    handleChange(data.value, 'phoneNumber');
                                }}
                                onBlur={
                                    () => { handleBlur('phoneNumber') }
                                }
                                error={!(!errors.phoneNumber || !touched.phoneNumber) ? true : false}
                            />
                            {
                                !(!errors.phoneNumber || !touched.phoneNumber) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.phoneNumber}</div>
                            }
                            <Form.Input className={!(!errors.email || !touched.email) ? 'mb-0' : ''}
                                required
                                fluid
                                label='Email Address'
                                onChange={(event, data) => {
                                    handleChange(data.value, 'email');
                                }}
                                onBlur={
                                    () => { handleBlur('email') }
                                }
                                error={!(!errors.email || !touched.email) ? true : false}
                            />
                            {
                                !(!errors.email || !touched.email) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.email}</div>
                            }
                            <Form.Input className={!(!errors.confirmEmail || !touched.confirmEmail) ? 'mb-0' : ''}
                                required
                                fluid
                                label='Confirm Email Address'
                                onChange={(event, data) => {
                                    handleChange(data.value, 'confirmEmail');
                                }}
                                onBlur={
                                    () => { handleBlur('confirmEmail') }
                                }
                                error={!(!errors.confirmEmail || !touched.confirmEmail) ? true : false}
                            />
                            {
                                !(!errors.confirmEmail || !touched.confirmEmail) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.confirmEmail}</div>
                            }
                            <Form.TextArea className={!(!errors.additionalInformation || !touched.additionalInformation) ? 'mb-0' : ''}
                                fluid
                                label='Accomodations / Additional Information'
                                onChange={(event, data) => {
                                    handleChange(data.value, 'additionalInformation');
                                }}
                                onBlur={
                                    () => { handleBlur('additionalInformation') }
                                }
                                error={!(!errors.additionalInformation || !touched.additionalInformation) ? true : false}
                            />
                            {
                                !(!errors.additionalInformation || !touched.additionalInformation) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.additionalInformation}</div>
                            }

                            <Button type='button' loading={isSubmitting} primary onClick={handleSubmit}>Submit</Button>
                            <Button type='button' onClick={() => { history.goBack() }}>Cancel</Button>
                        </Form>
                    </Grid.Column>
                    <Grid.Column>
                            <RegisteredJobSeekers
                                disabled={true}
                                listData={listData}
                                handleDelete={handleDeleteJobSeeker}
                                handleExport={() => { handleExport(parseInt(WId)) }}
                                isListLoading={isListLoading}
                            ></RegisteredJobSeekers>
                    </Grid.Column>
                </>
            }
            {
                submitSuccess &&
                <Message icon positive>
                    <Icon name='check circle outline' color='green' />
                    <Message.Content>
                        <Message.Header>Success</Message.Header>
                        <div>You have successfully registered your job seeker for the workshop. You and the job seeker will receive an email confirmation for this registration.</div>
                        <div style={{ marginTop: '0.5rem' }}>
                            <Button icon labelPosition='left' size='small' onClick={handleBackToList}>
                                <Icon name='arrow circle left' />
                                <span>Back to Job Seeker Workshops</span>
                            </Button></div>
                    </Message.Content>
                </Message>
            }

        </Grid>

    </Container>
}